import { topicsService } from "pro-features/pages/module start page/src/keyword analysis/topics/utils/flattenTopicsData";
import { useEffect, useState } from "react";

export function useTopicText(keyword: string, isTopic: boolean): string | undefined {
    const [topicText, setTopicText] = useState(undefined);

    useEffect(() => {
        const fetchTopicText = async () => {
            if (!isTopic) {
                return;
            }
            const topicName = (await topicsService.getTopicById(keyword)).Name;
            setTopicText(topicName);
        };

        fetchTopicText();
    }, [keyword, isTopic]);

    return topicText;
}
